export const MAX_LEVEL = 20;

// Cumulative XP needed to reach each level. threshold(L) = 100 * L * (L-1) / 2
// Index 0 = Level 1 (0 XP), index 19 = Level 20 (19000 XP).
export const LEVEL_THRESHOLDS: number[] = Array.from(
  { length: MAX_LEVEL },
  (_, i) => (100 * (i + 1) * i) / 2,
);

export const calculateLevel = (xp: number): number => {
  for (let i = LEVEL_THRESHOLDS.length - 1; i >= 0; i--) {
    if (xp >= LEVEL_THRESHOLDS[i]) return i + 1;
  }
  return 1;
};

export const getLevelProgress = (
  xp: number,
): { current: number; next: number; percent: number } => {
  const level = calculateLevel(xp);
  if (level >= MAX_LEVEL) {
    const top = LEVEL_THRESHOLDS[MAX_LEVEL - 1];
    return { current: top, next: top, percent: 100 };
  }
  const current = LEVEL_THRESHOLDS[level - 1];
  const next = LEVEL_THRESHOLDS[level];
  return { current, next, percent: ((xp - current) / (next - current)) * 100 };
};